const $ = window.jQuery;
const formSelector = ".js-price-request-form";

export function initPriceForm() {
    $(formSelector).validate({
        submitHandler: function (form) {
            $(form).find('[type="submit"]').addClass("is-loading");

            window.Form.ajaxPost(
                form,
                function (data) {
                    const message = $(".js-price-request-message");
                    message.slideUp(100);

                    if (data.status) {
                        $(formSelector).slideUp();
                    }

                    message
                        .toggleClass("c-msg--error", !data.status)
                        .toggleClass("c-msg--success", data.status)
                        .text(data.message)
                        .slideDown();

                    rEvent.dispatch("Recaptcha.execute");

                    $(form).find('[type="submit"]').removeClass("is-loading");
                },
                "json"
            );
        },
    });
}
